/* eslint-disable */
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { editBulkBEeffortDetails , editBulkFEeffortDetails } from '../../../../../../Api/request/dealEffort';
import UseAxios from '../../../../../../Api/http/http';
import { useSnackbar } from '../../../../../../Components/Snackbar/snackBarProvider';
import {  ToggleButton, ToggleButtonGroup } from "@mui/material";
import './bulkUpdate.scss';

export default function BulkUpdate({ open, handleClose, selectedIds, filterOptions, fetchRows, type}) {
  const [formValues, setFormValues] = React.useState({}); 
  const { snackbarOpen } = useSnackbar();

  const bulkUpdateOptions = (filterOptions || []).map((filter) => ({
    label: filter.name,
    field: filter.name.toLowerCase().replace(/\s+/g, ''), 
    options: filter.options.map((opt) => ({ id: opt.id, label: opt.label })), 
  }));

  const handleInputChange = (field, id) => {
    setFormValues((prev) => ({ ...prev, [field]: id }));
  };

  const handleBulkUpdate = async () => {
    try {
        let payload = {};  

        if (type === "BE") {
          payload = {
        id: selectedIds, 
        be_effort_complexity: formValues.beefforts,
        requirement_clarity: formValues.requirementclarity,
        technical_complexity: formValues.technicalcomplexity,
        external_integration: formValues.externalintegration,
      };  
        } else if (type === "FE") {
            payload = {
                id: selectedIds, 
                fe_effort_complexity: formValues.feefforts,
                requirement_clarity: formValues.requirementclarity,
                technical_complexity: formValues.technicalcomplexity,
                external_integration: formValues.externalintegration,
            };
        }


        const apiCall = type === "BE" ? editBulkBEeffortDetails : editBulkFEeffortDetails;
        const response = await UseAxios(apiCall(payload));
        
        if (response?.status === 200) {
          await fetchRows(); 
          handleClose(); 
          snackbarOpen('Your revised stories have been saved successfully.', 'success'); 
        } else {
          throw new Error(response?.data?.error || 'Failed to update data');
        }
      } catch (error) {
        console.error('Bulk update failed:', error);
        snackbarOpen('Oops! Please try again', 'error'); 
      }
};
  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}  sx={{ '& .MuiPaper-root': { borderRadius: '15px'}}}>
      <DialogTitle className="dialog-titles" id="customized-dialog-title">
        <Box className='bulk-update' >Bulk update.</Box>
        <Box className='issue-update'>{selectedIds.length} issues will be updated.</Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          {bulkUpdateOptions.map((option) => (
            <Grid item xs={6} key={option.label}>
              <div className='option-label'>{option.label}</div>
              <ToggleButtonGroup
                value={formValues[option.field]}
                exclusive
                onChange={(e, newValue) => {
                  if (newValue !== null) {
                    handleInputChange(option.field, newValue);
                  }
                }}
               className='toggle-button-group'
              >
                {option.options.map((opt) => (
                  <ToggleButton
                    key={opt.id}
                    value={opt.id}
                    className='toggle-button'
                  >
                    {opt.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          className='cancel-button'
        >
          Cancel
        </Button>
        <Button
          onClick={handleBulkUpdate}
          className='bulk-update-button'
        >
          Update Issues
        </Button>
      </DialogActions>
    </Dialog>
  );
}


BulkUpdate.propTypes = {
  open: PropTypes.bool.isRequired,  
  handleClose: PropTypes.func.isRequired,  
  selectedIds: PropTypes.array.isRequired,
  filterOptions: PropTypes.array.isRequired,
  fetchRows: PropTypes.func.isRequired, 
  type: PropTypes.string.isRequired
};